import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const mancoTypeValidator =
  (): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null => {
    if (control.value === '') {
      return { invalidMancoType: true };
    }
    return null;
  };

export const stringLengthValidator =
  (min: number, max: number): ValidatorFn =>
  (control: AbstractControl<string>): ValidationErrors | null => {
    const value = control.value || '';
    if (value.length < min || value.length > max) {
      return { invalidStringLength: true, min, max };
    }
    return null;
  };

export const quantityValidator =
  (orderline: { quantityDelivered: number; quantityReturned: number }): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null => {
    const quantity = control.value;
    const min = 0.01;
    const max = orderline.quantityDelivered - orderline.quantityReturned;

    if (quantity < min || quantity > max) {
      return { invalidQuantity: { min, max } };
    }
    return null;
  };

export const quantityRangeValidator =
  (deliveredQuantity: number, returnedQuantity: number): ValidatorFn =>
  (control: AbstractControl<number>): ValidationErrors | null => {
    const quantity = control.value;

    if (!quantity || isNaN(quantity) || quantity < 0.01 || quantity > deliveredQuantity - returnedQuantity) {
      return { invalidQuantity: true };
    }
    return null;
  };

export const followUpNeededValidator =
  (): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null => {
    if (control.value === '') {
      return { invalidFollowUpNeededOption: true };
    }
    return null;
  };
